module.exports = __webpack_public_path__ + "static/00004.af0bef84.jpg";